import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfilter',
})
@Injectable()
export class SearchFilterPipe implements PipeTransform {
  private NOT_FOUND = -1;
  transform(
    items: any[],
    field: string,
    secondField: string,
    value: string,
  ): any[] {
    let results;
    if (!items) {
      return [];
    }
    if (value === undefined || value.length < 2) {
      return;
    }

    value = value.toUpperCase();

    results = items.filter((it) => {
      let issue = it[field].toUpperCase();

      const fullIssue = it[secondField].toUpperCase();

      issue = issue.replace(' ', '');
      value = value.replace(' ', '');

      return (
        issue.indexOf(value) !== this.NOT_FOUND ||
        fullIssue.indexOf(value) !== this.NOT_FOUND
      );
    });

    return results;
  }
}
